export default __webpack_public_path__ + "static/media/pic-5.09f3ea63.png";